<template>
    <div class="container">
        <el-form ref="epmForm" :model="form" :rules="rules" label-position="right" style="width: 100%"
                 label-width="100px">
            <el-form-item prop="title" label="公司名">
                <el-col :span="13">
                    <el-input v-model="form.title" placeholder="请输入公司名称" autocomplete="off"></el-input>
                </el-col>
            </el-form-item>
            <el-form-item prop="endTime" label="结束时间">
                <el-date-picker
                        v-model="form.endTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        default-time="12:00:00">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="招聘联系人" :required="true">
                <el-col :span="6">
                    <el-form-item prop="manager">
                        <el-input v-model="form.manager" placeholder="姓名" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="1" style="text-align: center">
                    -
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="mobile">
                        <el-input v-model="form.mobile" maxlength="14" placeholder="电话号码" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item prop="intro" label="公司简介">
                <el-input :rows="5" maxlength="300" show-word-limit type="textarea" v-model="form.intro"
                          placeholder="请输入公司简介"
                          autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="jobDescription" label="职位描述">
                <el-input :rows="8" maxlength="600" show-word-limit type="textarea" v-model="form.jobDescription"
                          placeholder="请输入职位描述"
                          autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button @click="resetData">重 置</el-button>
                    <el-button type="primary" @click="saveData">确 定</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
    </div>

</template>

<script>
    export default {
        name: "EPMAddEdit",
        data() {
            return {
                apiUrl: process.env.VUE_APP_URL + "ma/employment/",
                form: {},
                rules: {
                    title: [
                        {required: true, message: '请输入公司名', trigger: 'blur'}
                    ],
                    endTime: [
                        {required: true, message: '请输入招聘有效时间', trigger: 'blur'}
                    ],
                    manager: [
                        {required: true, message: '请输入招聘联系人称呼', trigger: 'blur'}
                    ],
                    mobile: [
                        {required: true, message: '请输入招聘联系人电话号码', trigger: 'blur'}
                        /*{
                            pattern: /^((\+?[0-9]{1,4})|(\(\+86\)))?(13[0-9]|14[57]|15[012356789]|17[03678]|18[0-9])\d{8}$/,
                            message: '请输入正确的手机号码',
                            trigger: 'blur'
                        }*/
                    ],
                    intro: [
                        {required: true, message: '请输入公司简介', trigger: 'blur'}
                    ],
                    jobDescription: [
                        {required: true, message: '请输入职位描述', trigger: 'blur'},
                    ]
                }
            }
        },
        created() {
            if (this.$route.params.eid) {
                this.$axios.get(
                    process.env.VUE_APP_URL + 'getEpm?eid=' + this.$route.params.eid,
                ).then(({data}) => {
                    if (data.code === 200) {
                        this.form = JSON.parse(data.message);
                    }
                });
            }
        },
        methods: {
            resetData() {
                this.$refs['epmForm'].resetFields();
            },
            saveData() {
                this.$refs['epmForm'].validate((valid) => {
                    if (valid) {
                        let url = this.$route.params.eid ? this.apiUrl + 'modify' : this.apiUrl + 'add';
                        this.$route.meta.op = this.$route.params.eid ? 'modify' : 'add';
                        this.$axios.post(
                            url,
                            this.form
                        ).then(({data}) => {
                            if (data.code === 200) {
                                this.$message.success('招聘信息已保存');
                                this.$router.push('/main/employment');
                            } else {
                                this.$message.error('招聘信息保存失败');
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .container {
        margin: 0 30px 0 10px;
    }
</style>